import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalyticsSetPageInfo } from '../../../../cross-cutting-concerns/analytics/hooks/useAnalyticsSetPageInfo';
import { EmailVerification } from '../EmailVerification/EmailVerification';
import { ServiceRequestForm } from '../ServiceRequestForm/ServiceRequestForm';
import { AddServiceCase } from '../AddServiceCase/AddServiceCase';
import {
  ServiceRequestContext,
  useServiceRequest,
  useServiceRequestContext,
} from 'app/modules/service/context/ServiceContext';
import {
  selectIsLoggedIn,
  selectIsCheckingAuthentication,
  selectAuthenticationTokens,
} from 'app/cross-cutting-concerns/authentication/state/authenticationSelectors';
import { AuthenticationActions } from 'app/cross-cutting-concerns/authentication/state/authenticationActions';
import { LoadingPage } from 'lib/components/LoadingPage/LoadingPage';

const ServiceRequest = (): JSX.Element => {
  const dispatch = useDispatch();
  const isCheckingAuthentication = useSelector(selectIsCheckingAuthentication);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const authenticationTokens = useSelector(selectAuthenticationTokens);

  useAnalyticsSetPageInfo({});

  const { currentServiceStep, handleNavigateToAddServiceCase, handleEmail } = useServiceRequestContext();

  useEffect(() => {
    dispatch(AuthenticationActions.checkAuthentication());
  }, [dispatch]);

  useEffect(() => {
    if (isLoggedIn && authenticationTokens) {
      handleEmail(authenticationTokens.decoded.idToken.email);
      handleNavigateToAddServiceCase();
    }
  }, [isLoggedIn, authenticationTokens, handleEmail, handleNavigateToAddServiceCase]);

  if (isCheckingAuthentication) {
    return <LoadingPage />;
  }

  return (
    <>
      {currentServiceStep === 0 && <ServiceRequestForm />}
      {currentServiceStep === 1 && <EmailVerification />}
      {currentServiceStep === 2 && <AddServiceCase />}
    </>
  );
};

export const Service = (): JSX.Element => (
  <ServiceRequestContext.Provider value={useServiceRequest()}>
    <ServiceRequest />
  </ServiceRequestContext.Provider>
);
